<template>
  <LayoutCard class="chart-device-datapicker">
    <p style="font-weight: 600; margin-bottom: var(--spacer)">{{ device.name }}</p>
    <p v-if="device.variables.length > 0" class="hide-on-print">Variables :</p>
    <a
      v-for="variable in variables()"
      :title="variable.name"
      :class="{ selected: store_chart.getDevice?.selected.find((e) => e === variable.variableId) }"
      class="hide-on-print"
      @click="select_value(variable.variableId!)"
    >
      {{ variable.name }}
      ({{ getUnitLabel(unit_store.getUnit(variable.unitId)!) }})
    </a>
    <p v-if="device.sensors.length > 0" class="hide-on-print">Capteurs :</p>
    <a
      v-for="sensor in device.sensors"
      :title="sensor.name"
      class="hide-on-print"
      :class="{ selected: store_chart.getDevice?.selected.find((e) => e === sensor.sensorId) }"
      @click="select_value(sensor.sensorId!)"
    >
      {{ sensor.name }}
      ({{ getUnitLabel(unit_store.getUnit(sensor.unitId)!) }})
    </a>
    <CommonButton
      style="margin-left: auto; background-color: black; color: white"
      @click="store_chart.devices.forEach((d) => (d.selected = []))"
    >
      Déselectionner tout
    </CommonButton>
  </LayoutCard>
</template>

<script setup lang="ts">
import LayoutCard from '@/components/layout/LayoutCard.vue'
import type { components as HypervisionComponents } from '@/types/hypervision_schema'
import type { components as GatewayComponents } from '@/types/gateway_schema'
import type { ChartDeviceDatePickerData } from './ChartDeviceDatePicker.vue'
import { watch } from 'vue'
import { useChartStore } from '@/stores/store_chart'
import CommonButton from '@/components/common/CommonButton.vue'
import { useUnitStore } from '@/stores/store_unit'

const props = defineProps<{
  dates: ChartDeviceDatePickerData
  device: GatewayComponents['schemas']['SopravisionDeviceDTO']
}>()

function select_value(id: string) {
  store_chart.select(id)
  store_chart.fetch()
}

function getUnitLabel(unit: HypervisionComponents['schemas']['Unit']) {
  if (!unit) return
  switch (unit.code) {
    case 'M2':
      return 'm²'
    case 'MC':
      return 'm³'
    case 'm3J':
      return 'm³/j'
    case 'm3A':
      return 'm³/an'
    default:
      return unit.symbol
  }
}

function variables() {
  return props.device.variables.filter((e) => visible(e.customFields))
}

function visible(customfields?: string | null) {
  const normalize = customfields?.replaceAll("'", '"')
  if (!normalize) return false
  const json = JSON.parse(normalize)
  if (json.visible === 1) {
    return true
  }

  return false
}

const store_chart = useChartStore()
const unit_store = useUnitStore()
watch(props.dates, () => {
  store_chart.fetch()
})
</script>

<style scoped>
.chart-device-datapicker > a {
  transition: cubic-bezier(0.19, 1, 0.22, 1) 300ms;
  text-wrap: nowrap;
  display: block;
  padding: 10px;
  border-radius: var(--br-xsmall);
  background-color: var(--vc-gray3);
  font-weight: 400;
  font-size: 12px;
  line-height: 14.4px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--vc-gray4);
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chart-device-datapicker > a:not(:last-child) {
  margin-bottom: 10px;
}

.selected {
  background-color: var(--vc-primary) !important;
  color: white !important;
}

a > span {
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}
</style>
